import { useEffect } from "react";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { FloatingWhatsApp } from "./FloatingWhatsApp";
import { Footer } from "./Footer";
import { Header } from "./Header";

export function Layout() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <>
      <a className="skip-link" href="#conteudo-principal">Saltar para o conteúdo</a>
      <Header />
      <main id="conteudo-principal" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}
